const en_translation = {
  register_button_label: 'Register a kit',
  sign_in_button_label: 'Sign in',
  signed_in_as: 'Signed in as',
  sign_out: 'Sign out',
  change_language_label: 'Change language',
  order_collection_set_label: 'Order a collection kit',
  order_analysis_label: 'Order a test',
  yes: "Yes",
  no: "No",
  abort: "Abort",
  collection_set: "Collection kit",
  required: "Required!",
  close: "Close",
  submit: "Submit",
  cancel: "Cancel",
  select: "Select",
  order: "Order",
  change: "Change",
  back: "Back",
  summary: "Summary",
  password: "Password",
  password_confirm: "Confirm Password", 
  change_password: "Change Password",
  wrong_pass: "Incorrect password!",
  register_yourself: "Sign up",

  navigation: {
    welcome: 'Welcome',
    how_it_works: 'How it works',
    help: 'Help',
    about_us: 'About us',
    packages: 'Our services',
    our_lab: "Our Lab",
    contact: "Contact details",
    privacy_policy:"Privacy Policy",
    faq:"FAQ",
    why_you_should_know_your_genome: "Why us?",
  },

  how_it_works:{
    description:"To perform genetic testing, we apply state-of-the-art technology with the widest possible range of genetic error detection: Whole-Genome Sequencing (WGS). It allows us to detect all potential variations in the entire genome. Thanks to WGS, one test allows to read 3 billion genetic data letters with 30-fold coverage, or the whole human genome sequence. For the genome analysis we use  blood samples, which are collected at Genomed blood test clinic or at Diagnostyka centres, or saliva samples collected using a dedicated kit. The samples are sent to our Warsaw lab to be analysed. You can discuss your genetic test result with one of our clinical geneticists – you can visit us in Warsaw or have a conversation on-line.",
    download_files: "Documents for downloading:",
    file_1: "Deklaracja świadomej zgody na badanie całogenomowe (PDF) ",
    file_2: "Oświadczenie dotyczące danych osobowych (PDF) "
  },

  why_worth:{
      description:"Why it's worth it placeholder"
    },

    why_you_should_know_your_genome:{
      title: "Is getting to know your genome a good idea?",
      section_1:'<strong><p>The human genome comprises basic information on the structure and functions of our body recorded in a chemical form. The DNA (or deoxyribonucleic acid) is the carrier of genetic information of all living organisms. Genetic information is coded in a sequence in the DNA chain of its four components (nucleotides), or genetic code letters: A, C, G, and T.</p><p>The human genome is composed of 3 billion such units. If converted to text, it would have the size of 400 volumes of an encyclopaedia. Our genetic material takes the form of 23 chromosome pairs: one chromosome from each pair comes from one parent, and the other from the other parent. The human genome comprises about twenty thousand genes, or DNA regions, that work as instructions for our body on how to grow and work.</p></strong>',
      section_1_extended:'<p>Each gene has two copies (apart from those contained in X and Y chromosomes). One copy comes from your mother, and the other from your father. It happens sometimes that a copy is altered (having a variant or a mutation), which makes it work abnormally. Such alterations of the genetic material (letter substitutions, deletions, insertions, and duplications) are detected via genome analysis.</p><p>People with such a gene alteration are called genetic disease carriers. Usually they are healthy and have no genetic disease symptoms, but they may transfer altered gene copies to their children. There are dominant genetic disorders, such as Huntington’s disease or brittle bone disease, which occur when one gene copy is mutated. More frequently, though, genetic diseases are recessive, for example cystic fibrosis and phenylketonuria. Children of carriers get them if gene copies from both parents are altered.</p><p><span id="ryzyka">Preventive genome tests let you know if you are likely to develop genetic diseases at later stages in life and if you may transfer altered gene copies and resulting diseases to your children.</span></p>',
      section_2:'<strong><p><span id="profilaktyka">Genome analysis is the first step towards personalised medicine.</p><p>Information contained in the genome becomes meaningful only after an in-depth analysis by professionals (experts in bioinformatics, molecular biologists, diagnosticians, and clinical geneticists) based on most recent data from genetic databases. Physicians use genome analysis results to recommend individual therapy or preventive actions to their patients.</p></strong>',
      section_2_extended:'<p>In the case of the majority of genetic diseases, it is only possible to take preventive actions and to treat their symptoms. Yet, there are more and more diseases whose early prevention and treatment can stop their development or prevent potential complications. <span id="terapia">It is now possible to repair altered genes by way of gene therapy (for example to treat spinal muscular atrophy and Leber congenital amaurosis) and to edit the genome. One of the treatment stages is a stem cell transplant, or introduction of healthy gene copies from stem cell genomes.</span></p><p><span id="odpowiedz-na-leki"><strong>Genome variety is the basis of individual response to medicines</strong>, such as analgesics, antidepressants, antiatherosclerotics, and cancer drugs. At present, selected genome fragment analysis helps select the most effective treatment methods, for example in cancer treatment. Whole genome analysis will constitute the basis for informed medicine selection throughout our lives, hence a pharmacogenomic test report is an important element of genetic testing results.</span></p>',
      what_is_included_in_the_genome_analysis_report:"What is in a genome analysis report?",
      section_3:'<p>We provide a whole genome map and data from subsequent steps of its analysis (on a data carrier), as well as a detailed report on major genetic problems and resulting potential risk of developing genetic diseases or transferring such diseases to your children. The report is the result of sequence analysis of over five thousand genes responsible for genetic diseases. It also includes reports on personalised response to medicines and diet recommendations (pharmacogenomic and nutrigenomic reports).</p><p>Higher risk of developing a disease does not automatically mean you will develop it, as apart from genetic factors there it is also the effect of environmental factors. Selecting and keeping a proper diet and keeping fit may prevent a disease, while routine check-ups allow to detect it and start treatment at an early stage (as is the case with cancer).</p><p><span id="jedno-badanie">As the knowledge of the human genome and consequences of specific mutations is increasing on an ongoing basis, and new therapies for genetic diseases are being developed, at the patient’s request we can update genetic test result interpretations as well as information on proper preventive actions and available therapies.</p><p>One of the major advantages of genetic testing is that we can re-analyse individual genome sequences if our client develops a disease to pinpoint its cause and to find the most suitable therapy.</span></p>',
    },

  footer:{
    copyright:"Copyright 2024 © Genomed S.A. All right reserved."
  },

  breadcrumb_collection_set: {
    collection_sets: 'Collection kits',
    shipment_data: 'Delivery details',
    summary: 'Summary',
    payment: 'Payment',
    confirmation: 'Confirmation'
  },
  breadcrumb_analysis_order: {
    collection_set: 'Collection kit',
    analysis_range: 'Analysis options',
    additional_tests: 'Additional tests',
    report: 'Report form',
    data_carrier: 'Data storage device',
    survey: 'Survey',
    consultation: 'Medical consultation',
    summary: 'Summary',
    payment: 'Payment'
  },

  collection_set_order: {
    header: 'Ordering collection kits',
    order_set_only: 'Order only a collection kit',
    price: 'Price',
    continue_button_label: 'Continue',
    back_button_label: 'Back',
    pcs: 'kit(s)',
    select_delivery_method: 'How would you like it delivered?',
    delivery_types: {
      courier: 'Courier',
      collect_in_person: 'I’ll collect it myself'
    },
    delivery_method: "Delivery",
    delivery_adress: "Your address",
    payment_methods: {
      bank_transfer: 'Bank transfer',
      online_transfer: 'On-line payment'
    },
    payment_details: "Payment details",
    name: 'Name',
    surname: 'Surname',
    adress: "Address",
    street_no: 'Street, house No., apartment No.',
    postal_code: 'Postal code',
    city: 'City',
    street_and_local_no: "Street, house No., apartment No.",
    phone: 'Phone No.',
    alerts: {
      please_provide_shipment_address: 'State delivery address'
    },
    summary: 'Summary',
    total: 'Total',
    change_button_label: 'Change',
    order_button_label: 'Place order and commit to pay',
    order_placed_header: 'Your order has been placed',
    your_order_number: 'Your order number:',
    pay_button_label: 'Pay',
    shipment_label: 'Delivery',
    order_new_set: "Order a new collection kit",
    set_is_registered: "My kit is already registered",
    use_set_nr: "I’ll use my collection kit No.",
    select_collection_set: "Select your collection kit:",
    order_set_confirm: "I order a collection kit",
  },

  analysis_order: {
    header: 'Select an option:',
    more_info_button_label: 'More',
    select_package_button_label: 'Select',
    selected_package_label: 'Selected option',
    change_package_button_label: 'Change',
    price: 'Price',
    continue_button_label: 'Continue',
    text1: "EN_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.",
    text2: "EN_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.",
    text2_p1: "Ut enim ad minim",
    text2_p2: "Quis nostrud exercitation",
    text3: "EN_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, ed do eiusmod tempor incididunt.",
    text3_p1: "Ut enim ad minim",
    text3_p2: "Quis nostrud exercitation",
    text4: "EN_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, ed do eiusmod tempor incididunt.",
    text4_p1: "Ut enim ad minim",
    text4_p2: "Quis nostrud exercitation",
    text5: "EN_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, ed do eiusmod tempor incididunt.",
    text5_p1: "Ut enim ad minim",
    text5_p2: "Quis nostrud exercitation",
    text6: "EN_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, ed do eiusmod tempor incididunt.",
    choose_medium: "Choose medium on which Your genome will be stored*",
    choose_medium_delivery_method: "Choose medium delivery method",
    data_storage_medium: "Data storage device",
    special_casing: "Exceptional packaging!",
    special_casing_info: "Select exceptional packaging for the USB stick containing your genome details.",
    see_offer: "Available soon"
  },

  consultation:{
    date_from: "From",
    date_to: "To",
    search: "Search",
    selected_date:"Selected medical consultation date",
    info1: "The medical consultation will be held on-line. It is not obligatory. Select the date:",
    accept_go_to_summary: "Accept and proceed to summary",
    consultation: "Medical consultation",
  },

  register: {
    header: 'Register your collection kit using a code from the scratch-off card',
    continue_button_label: 'Proceed to survey',
    enter_password_header: 'Set up your password',
    password: 'Password',
    email: 'E-mail',
    phone_no: "Phone No.",
    confirm_password: 'Confirm password',
    register_button_label: 'Save and create my account',
    alerts: {
      empty_password: 'Enter password',
      incorrect_code: 'Incorrect code',
      incorrect_code_given: 'The code you entered is incorrect',
      passwords_different: 'Passwords do not match'
    },
    collection_set_registered_message: 'Your kit has been registered.',
    you_can_sing_in: 'You can now sign in using the code from the kit and your password.',
    go_to_home_page: 'Go back to the main page',
    code_placement: "Code on the scratch-off card.",
    code_correct:"The code is correct!",
    cancel_confirm: "Are you sure you want to cancel?",
    wrong_pass: "Incorrect password!",
    wrong_email: "Incorrect e-mail!",
    code: "Code",
    login_using_code: "Sign in using collection kit number",
    share_email_text: "Enter you e-mail so we can contact you (optional)",
    text1: "en_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.",
    text2: "en_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.",
  },

  sign_in: {
    code: 'Code',
    password: 'Password'
  },

  surveys: {
    fill_correct: "Fillout/correct",
    read_more: "Read more",
    extended_survey: "Extended survey",
    question_no: 'Question no.',
    sex_section_info_title: 'SEX',
    sex_section_info_text: 'To make sure that genetic sex is concordant with physical sex; rarely, that may not be the case and it will be important for the interpretation of the results; this question, thus, refers to your external sex physical characteristics at the time of your birth',
    family_origin_section_info_title: 'FAMILY ORIGIN',
    family_origin_section_info_text: 'The frequency and impact of certain variants are influenced by the genetic background and this, in turn, is influenced by genetic ancestry history; geographic origin, ethnicity and primary language, all help to characterize genetic ancestry',
    ancestry_section_info_title: 'ANCESTRY AND GEOGRAPHIC ORIGIN',
    biological_family_section_info_text: 'Parents',
    biological_family_section_info_title: 'BIOLOGICAL FAMILY',
    personal_health_section_info_title: 'PERSONAL HEALTH',
    personal_health_section_info_text: 'As explained in the beginning, some current conditions you may be carrying may have a genetic cause and/or predisposition; some of the genetic risk/predisposition variants we may report, if you so chose, may be conditioned by this information',
    basic: {
      questions: {
        1: {
          title: 'Date of birth',
          info: 'The probability of many diseases depends on age',
          inputs: {
            1: {
              text: 'Enter'
            },
            2: {
              text: 'I don\'t know'
            }
          }
        },
        2: {
          info: 'The probability of many diseases depends on age',
          title: 'In case you don’t know your date of birth, about how old are you?'
        },
        3: {
          title: 'BASED ON THE INFORMATION PROVIDED IN THE INTRODUCTION, WHAT TYPE OF INFORMATION ARE YOU INTERESTED IN KNOWING? (please select one or more of, or all, the following options, or click on "Don’t know" or "Prefer not to answer")',
          inputs: {
            1: {
              text: '"clinically actionable high penetrant variants", that is, variants that are very likely to have certain effects on my own health and whose effects can be altered by currently available medical interventions.'
            },
            2: {
              text: '"non-clinically actionable high penetrant variants", that is, variants that are very likely to have certain effects on my own health but whose effects cannot be altered by currently available medical interventions.'
            },
            3: {
              text: '"increased susceptibility variants", that is, variants that only increase slightly, in comparison with the population, the probability of the occurrence of some more or less common health problems.'
            },
            4: {
              text: '"reproductive relevant variants", that is, variants that are relevant only for individuals contemplating reproduction and only if their reproductive partners also have pathogenic variant in the same genes. '
            },
            5: {
              text: 'Don\'t know yet'
            },
            6: {
              text: 'Prefer not to answer'
            },
          }
        },
        4: {
          title: 'IS THERE ANYTHING ELSE THAT YOU EXPECT FROM THIS STUDY OF YOUR GENOME?',
          info: 'Please tell us about your expectations, so that we can inform you about the possibility of our study and analysis of your genome to meet them',
          inputs: {
            1: {text: 'Yes'},
            2: {text: 'No'},
            3: {text: 'Don\'t know yet'},
            4: {text: 'Prefer not to answer'}
          }
        },
        5: {
          title: 'What is your sex?',
          inputs: {
            1: {text: 'Male'},
            2: {text: 'Female'},
            3: {text: 'Other, ambiguous'},
            4: {text: 'Prefer not to answer'},
          }
        },
        6: {
          title: 'Were you adopted?',
          info: 'Adopted individuals are unlikely to be able to provide accurate information about their biological ancestry; if you were adopted, we will limit the questions in this section)',
          inputs: {
            1: {text: 'No'},
            2: {text: 'Yes'},
            3: {text: 'Don\'t know, but it is possible'},
            4: {text: 'Prefer not to answer'},
          }
        },
        7: {
          title: 'In which country were you born?',
          inputs: {
            1: {text: 'Country'},
            2: {text: 'Don\'t know'},
            3: {text: 'Prefer not to answer'},
          }
        },
        8: {
          title: 'In which country do you live?',
          inputs: {
            1: {text: 'Country'},
            2: {text: 'Prefer not to answer'},
          }
        },
        9: {
          title: 'Where was your biological mother born?',
          inputs: {
            1: {text: 'Country'},
            2: {text: 'Don\'t know'},
            3: {text: 'Prefer not to answer'},
          }
        },
        10: {
          title: 'Where was your biological father born?',
          inputs: {
            1: {text: 'Country'},
            2: {text: 'Don\'t know'},
            3: {text: 'Prefer not to answer'},
          }
        },
        11: {
          title: 'What race/continent of origin/ethnicity do you consider yourself to be? Please select 1 or more of these categories',
          inputs: {
            1: {text: 'WHITE/EUROPEAN'},
            2: {text: 'ASHKENAZI JEWISH'},
            3: {text: 'SEPHARDIC JEWISH'},
            4: {text: 'BLACK/SUB-SAHARIAN AFRICAN'},
            5: {text: 'NORTH AFRICAN'},
            6: {text: 'MIDDLE EASTERN'},
            7: {text: 'ASIAN INDIAN'},
            8: {text: 'ASIAN CHINESE'},
            9: {text: 'ASIAN FILIPINO'},
            10: {text: 'ASIAN JAPANESE'},
            11: {text: 'ASIAN KOREAN'},
            12: {text: 'ASIAN VIETNAMESE'},
            13: {text: 'PACIFIC ISLANDER NATIVE (SPECIFY):'},
            14: {text: 'OTHER ASIAN (SPECIFY):'},
            15: {text: 'SOUTH AMERICA NATIVE'},
            16: {text: 'NORTH AMERICA NATIVE'},
            17: {text: 'SAME OTHER (SPECIFY):'},
            18: {text: 'Don\'t know'},
            19: {text: 'Prefer not to answer'},
          }
        },
        12: {
          title: 'Self-Reported Height. How tall are you without shoes (in cm)?',
          info: 'To calculate Body Mass Index (BMI) – BMI is a measure of weight status; some weight disequilibria may be a symptom of, or a predisposition factor for, diseases, of which some may have a genetic cause or predisposition',
          inputs: {
            1: {
              text: 'Enter'
            }
          }
        },
        13: {
          title: 'Self-Reported Weight. How much do you weigh without clothes and shoes (rounded to kg)? (If you are currently pregnant, how much did weigh before your pregnancy?)',
          info: 'To calculate Body Mass Index (BMI) – BMI is a measure of weight status; some weight disequilibria may be a symptom of, or a predisposition factor for, diseases, of which some may have a genetic cause or predisposition',
          inputs: {
            1: {
              text: 'Wprowadź'
            }
          }
        },
        14: {
          title: 'Do you have or ever had a diagnosis of any clinical conditions?',
          info: 'A clinical condition may be an actual disease, a symptom of, or a predisposition factor for, diseases, of which some may have a genetic cause or predisposition',
          inputs: {
            1: {text: 'Yes'},
            2: {text: 'No'},
            3: {text: 'Don\'t know'},
            4: {text: 'Prefer not to answer'},
          }
        },
        15: {
          title: 'Please select which of the following diseases/symptoms you have or had',
          categories: {
            1: {
              title: 'Cancer',
              inputs: {
                1: {title: 'Bone Cancer'},
                2: {title: 'Brain Cancer'},
                3: {title: 'Breast Cancer'},
                4: {title: 'Colon Cancer'},
                5: {title: 'Colorectal Cancer'},
                6: {title: 'Esophageal Cancer'},
                7: {title: 'Familial adnenomatous polyposis (FAP)'},
                8: {title: 'Gastric Cancer'},
                9: {title: 'Lynch Syndrome/Hereditary non-polyposis colorectal cancer (HNPCC)'},
                10: {title: 'Kidney Cancer'},
                11: {title: 'Leukemia'},
                12: {title: 'Liver Cancer'},
                13: {title: 'Lung Cancer'},
                14: {title: 'Muscle Cancer'},
                15: {title: 'Ovarian Cancer'},
                16: {title: 'Pancreatic Cancer'},
                17: {title: 'Prostate Cancer'},
                18: {title: 'Rectal Cancer'},
                19: {title: 'Skin Cancer'},
                20: {title: 'Thyroid Cancer'},
                21: {title: 'Uterine Cancer'},
                22: {title: 'Other Cancer (specify)'},
                23: {title: 'Unknown Cancer'},
              }
            },
            2: {
              title: 'Clotting Disorder',
              inputs: {
                24: {title: 'Clotting Disorder'},
                25: {title: 'Deep Vein Thrombosis (DVT)'},
                26: {title: 'Pulmonary Embolism'},
                27: {title: 'Other Clotting Disorder (specify)'},
                28: {title: 'Unknown Clotting Disorder'},
              }
            },
            3: {
              title: 'Diabetes',
              inputs: {
                29: {title: 'Type 1 Diabetes'},
                30: {title: 'Type 2 Diabetes'},
                31: {title: 'Gestational Diabetes'},
                32: {title: 'Impaired Fasting Glucose'},
                33: {title: 'Impaired Glucose Tolerance'},
                34: {title: 'Insulin Resistance'},
                35: {title: 'Maturity Onset Diabetes mellitus in Young (MODY)'},
                36: {title: 'Pre-Diabetes'},
                37: {title: 'Other type of diabetes (specify)'},
                38: {title: 'Unspecified type of diabetes'},
              }
            },
            4: {
              title: 'Gastrointestinal Disorder',
              inputs: {
                39: {title: 'Colon Polyp'},
                40: {title: 'Crohn\'s Disease'},
                41: {title: 'Congenital defect'},
                42: {title: 'Familial adnenomatous polyposis (FAP)'},
                43: {title: 'Gastrointestinal Disorder'},
                44: {title: 'Irritable Bowel Syndrome'},
                45: {title: 'Lynch Syndrome/Hereditary non-polyposis colorectal cancer (HNPCC)'},
                46: {title: 'Ulcerative Colitis'},
                47: {title: 'Other Gastrointestinal Disorder (specify)'},
                48: {title: 'Unknown Gastrointestinal Disorder'},
              }
            },
            5: {
              title: 'Heart Disease',
              inputs: {
                49: {title: 'Angina / Coronary Artery Disease'},
                50: {title: 'Congenital defect'},
                51: {title: 'Heart Attack'},
                52: {title: 'Other Heart Disease (specify)'},
                53: {title: 'Unknown Heart Disease'},
              }
            },
            6: {
              title: 'Kidney Disease',
              inputs: {
                54: {title: 'Cystic Kidney Disease'},
                55: {title: 'Congenital defect'},
                56: {title: 'Diabetic Kidney Disease'},
                57: {title: 'Kidney Nephrosis'},
                58: {title: 'Nephritis'},
                59: {title: 'Other Kidney Disease (specify)'},
                60: {title: 'Uknown Kidney Disease'},
              }
            },
            7: {
              title: 'Lung Disease',
              inputs: {
                61: {title: 'Asthma'},
                62: {title: 'COPD'},
                63: {title: 'Chronic Bronchitis'},
                64: {title: 'Chronic Lower Respiratory Disease'},
                65: {title: 'Congenital defect'},
                66: {title: 'Emphysema'},
                67: {title: 'Influenza/Pneumonia'},
                68: {title: 'Other Lung Disease (specify)'},
                69: {title: 'Unknown Lung Disease'},
              }
            },
            8: {
              title: 'Psychological/Psychiatric Disorder',
              inputs: {
                70: {title: 'Anxiety'},
                71: {title: 'Attention Deficit Disorder-Hyperactivity'},
                72: {title: 'Autism'},
                73: {title: 'Bipolar Disorder'},
                74: {title: 'Depression'},
                75: {title: 'Eating Disorder'},
                76: {title: 'Obsessive Compulsive Disorder'},
                77: {title: 'Panic Disorder'},
                78: {title: 'Personality Disorder'},
                79: {title: 'Post Traumatic Stress Disorder'},
                80: {title: 'Schizophrenia'},
                81: {title: 'Social Phobia'},
                82: {title: 'Other Psychological/Psychiatric Disorder (specify):'},
                83: {title: 'Unknown Psychological/Psychiatric Disorder'},
              }
            },
            9: {
              title: 'Eye Disease',
              inputs: {
                84: {title: 'Pigment retinitis or retinosis'},
                85: {title: 'Macular degeneration'},
                86: {title: 'Glaucoma'},
                87: {title: 'Cataracts'},
                88: {title: 'Other eye disease that caused blindness'},
                89: {title: 'Other eye disease (specify):'},
                90: {title: 'Unknown eye disease'},
              }
            },
            10: {
              title: 'Hearing impairment',
              inputs: {
                91: {title: 'With speech impairment'},
                92: {title: 'Without speech impairment'},
              }
            },
            11: {
              title: 'Some type of neurologic childhood, youth or adult disorder',
              inputs: {
                93: {title: 'Intellectual disability'},
                94: {title: 'Epilepsy or seizure disorder'},
                95: {title: 'Congenital defect of the brain or spinal cord'},
                96: {title: 'Multiple sclerosis'},
                97: {title: 'Amyotrophic Lateral Sclerosis'},
                98: {title: 'Huntington Chorea'},
                99: {title: 'Parkinson disease'},
                100: {title: 'Syncope (one or more episodes, any time in life, of sudden, temporary self limited, loss of consciousness)'},
                101: {title: 'Autism'},
                102: {title: 'Other neurologic disease (specify):'},
                103: {title: 'Unknown neurologic disease'},
              }
            },
            12: {
              title: 'Skeletal Disease',
              inputs: {
                104: {title: 'Osteoporosis'},
                105: {title: 'Rickets or osteomalacia'},
                106: {title: 'Any congenital bone deformation or malformation'},
                107: {title: 'Other skeletal disease (specify):'},
              }
            },
            13: {
              title: 'Skin Disease',
              inputs: {
                108: {title: 'Ichtyosis'},
                109: {title: 'Epidermolysis bullosa'},
                110: {title: 'Other skin disease (specify):'},
                111: {title: 'Unknown skin disease'},
              }
            },
            14: {
              title: 'Auto-immune / Rheumatic disease',
              inputs: {
                112: {title: 'Rheumatoid Arthritis'},
                113: {title: 'Systemic Lupus Erythematous'},
                114: {title: 'Ankylosing Spondylitis'},
                115: {title: 'Other auto-immune disease (specify):'},
                116: {title: 'Unknown auto-immune disease'},
              }
            },
            15: {
              title: 'Endocrinologic disorder',
              inputs: {
                117: {title: 'Hyperthyroidism'},
                118: {title: 'Hypothyroidism'},
                119: {title: 'Addison disease'},
                120: {title: 'Cushing disease'},
                121: {title: 'Other endocrinologic disease (specify):'},
                122: {title: 'Unknown endocrinologic disease'},
              }
            },
            16: {
              title: 'Other Diseases',
              inputs: {
                123: {title: 'Allergy/ies (specify):'},
                124: {title: 'High Cholesterol'},
                125: {title: 'Hypertension'},
                126: {title: 'Septicemia'},
                127: {title: 'Stroke/Brain Attack'},
                128: {title: 'Other disease (specify):'},
                129: {title: 'Unknown disease'},
              }
            }
          }
        }
      }
    }
  },

  compare_packages:{
    compare_packages: "Our services – compare tests",
    description:"We invite you to get acquainted with the spectrum of the whole-genome testing we offer. You can select a test that suits your needs best, from an option for those who wish to analyse their genome themselves to an option with a comprehensive preventive analysis, accompanied by tests using other technologies.",
    attribute1: "Genome sequence reading",
    attribute2: "Bioinformatic analysis",
    attribute3: "Clinical interpretation",
    attribute4: "Pharmacogenomics report",
    attribute5: "Structural variants (NGS analysis)",
    attribute6: "Price",
    attribute7: "Extended structural variant analysis",
    attribute8: "Report update",
    order_btn: "Order"
  },

  sets:{
    our_sets: "Test options",
    basic: "Silver",
    basic_info: "Genome sequence reading with a bioinformatic analysis",
    basic_for_who: "This option is recommended to those who wish to analyse their genome themselves. It does not include an assessment of detected variants’ effect on your health.",
    basic_description: "The test includes:<ol><li>Genome sequence reading.</li><li>A genome analysis report featuring the results of a basic bioinformatic analysis which consists in identification of point mutations and deletions/insertions of up to 150 bases in the entire genome sequence, variant annotations, taking into account variant location, genotype, gene affiliation, records using the HGVS nomenclature, effect on protein, dbSNP identifier, and frequency in population databases. The report also states if a given variant is present in ClinVar, with a link to the database.</li><li>Genomed provides clients with genome data that constitute the basis of bioinformatic analysis in FASTQ, BAM, and VCF file formats, as well as datasets of identified variants with annotations, which constitute the basis of the test result.</li></ol>",
    basic_opt1:"Genome sequence reading",
    basic_opt2:"Basic bioinformatic analysis",
    advanced: "Blue",
    advanced_info: "Genome diagnostic analysis",
    advanced_for_who: "This option is recommended to those who seek a professional analysis of genetic disease risk and possible preventive actions to be taken.",
    advanced_description: "The test includes: <ol><li>Genome sequence reading.</li><li>It checks for all pathogenic or potentially pathogenic variants within the genome, entered into ClinVar. The report includes information significant to the person who is tested, but also to their family members and descendants, such as: – the risk of developing cancer; – the risk of developing cardiovascular diseases, including the risk of hypercholesterolemia, sudden cardiac death, cardiomyopathy, and aortic aneurysm; – the risk of developing neurodegenerative diseases, such as Alzheimer’s or Parkinson’s; – the risk of developing disability due to loss of sight, hearing, or ability; – the risk of developing infertility, pregnancy loss; – the risk of having children with genetic diseases.<br> The report on this test section concerns only the variants from ClinVar (globally recognised genetic variant database) whose association with a disease has been confirmed.</li><li>Verification of the presence of selected recognised variants of high frequency in the Polish and general population (>1%), whose clinical significance has been scientifically proven, but cannot be considered pathogenic or likely pathogenic according to the ACMG classification.</li><li>Compilation of variants with well-documented significance to pharmacological treatment detected in the genome. The presence of specific genetic variants influences therapy effectiveness, affects medicine doses, and may contraindicate therapy due to high risk of side effects. Awareness of individual genetic predispositions in a drug metabolism allows to select effective therapy, tailored to the patient’s needs.</li><li>Compilation of nutrigenomic variants that relate to lifestyle in a broad sense. Genomic data are the basis of an analysis for genetic variants that constitute genetic predispositions which may be triggered by diet, such as food intolerance. Based on analysis results, individual dietary advice is provided.</li></ol>",
    advanced_opt1:"Compilation of detected known pathogenic variants",
    advanced_opt2:"Compilation of significant pharmacogenomic and nutrigenomic variants",
    advanced_opt3:"Mitochondrial genome analysis",
    advanced_opt4:"NGS structural variant analysis",
    premium: "Golden",
    premium_info: "Comprehensive genome analysis, updated biannually",
    premium_for_who: "This option is recommended to those who seek a professional analysis of genetic disease risk, possible preventive actions to be taken, and regular updates.",
    premium_description: "The test includes: <ol><li>Genome sequence reading.</li><li>It checks for all pathogenic or potentially pathogenic variants within the genome, entered into ClinVar. The report includes information significant to the person who is tested, but also to their family members and descendants, such as: – the risk of developing cancer; – the risk of developing cardiovascular diseases, including the risk of sudden cardiac death, cardiomyopathy, and aortic aneurysm; – the risk of developing neurodegenerative diseases, such as Alzheimer’s or Parkinson’s; – the risk of developing disability due to loss of sight, hearing, or ability; – the risk of developing infertility, pregnancy loss; – the risk of having children with genetic diseases.<br> The report on this test section concerns only the variants from ClinVar (globally recognised genetic variant database) whose association with a disease has been confirmed.</li><li>Verification of the presence of selected recognised variants of high frequency in the Polish and general population (>1%), whose clinical significance has been scientifically proven, but cannot be considered pathogenic or likely pathogenic according to the ACMG classification.</li><li>Compilation of variants with well-documented significance to pharmacological treatment detected in the genome. The presence of specific genetic variants influences therapy effectiveness, affects medicine doses, and may contraindicate therapy due to high risk of side effects. Awareness of individual genetic predispositions in medicine metabolism allows selection of effective therapy, tailored to the patient’s needs.</li><li>Compilation of nutrigenomic variants that relate to lifestyle in a broad sense. Genomic data constitute the basis of an analysis for genetic variants that constitute genetic predispositions which may be triggered by diet, such as food intolerance. Based on analysis results, individual dietary advice is provided.</li><li>In the case of selected diseases where the molecular defect that triggers the disease cannot be captured using NGS, other molecular diagnostic methods will be applied, such as MLPA, supplementary Sanger sequencing, or RFLP.</li><li>Two genome data analysis updates (at the client’s request).</li></ol>",
    premium_opt1:"Extended structural variant analysis (using MLPA)",
    premium_opt2:"Updated information on available therapies",
    premium_opt3:"Updated clinical interpretation of detected variants",
    premiump: "Premium +",
    premiump_info: "en_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.",
    premiump_opt1:"en_ Ut enim ad minim",
    premiump_opt2:"premiump_opt2",
    premiump_opt3:"premiump_opt3",
    read_more: "Read more",
    basic_price: "6000 PLN",
    basic_old_price: "7000 PLN",
    advanced_price: "9000 PLN",
    advanced_old_price: "12500 PLN",
    premium_price: "9900 PLN",
    premium_old_price: "14500 PLN",
    book_a_consultation: "Register for a consultation with a clinical geneticist",
    basic_link: "https://diagnostyka.genomed.pl/en/wyszukiwarka-badan/?qproduct=genom-s&type=shop.Product",
    advanced_link: "https://diagnostyka.genomed.pl/en/wyszukiwarka-badan/?qproduct=genom-blue&type=shop.Product",
    premium_link: "https://diagnostyka.genomed.pl/en/wyszukiwarka-badan/?qproduct=genom-z&type=shop.Product",
  },

  panel:{
    surveys: "Surveys",
    appointments: "Consultations",
    my_account: "My Account",
    my_analysis: "My Analysis",

  },

  my_analysis:{
    no_analysis_yet: "No analyses yet.",
    collection_set_no: "Collection kit No.",
    registration_date: "Registration date",
    add_new_collection_set: "Add new collection kit"
  },

  login_page:{
    log_in: "Sign in",
    text1: "EN_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud. ",
    code_beneath_scratch: "The code is on the scratch-off card.",
    invalid_code: "The code is incorrect",
    code_ok: "Correct kit code!",
    dont_have_account: "Don’t have an account?",
    text2: "EN_ Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud. ",
    collection_set_code: "Enter the code from the collection kit", 
    enter_password: "Enter password",
    wrong_code_or_pass: "Incorrect code or password",
  },
  home:{
    title: "Preventive genome analysis",
    title2: "Safe, from anywhere",
    pro1: "On-line orders and consultations",
    pro2: "Professional report with a genetic consultation",
    pro3: "Diagnostic report",
    pro4: "POLGENOM database with genomes of healthy long-lived Poles as reference",
    pro5: "Regular report updates available",
    pro6: "Access to full genomic data",
    pro_bottom: "Performed by the Genomed team with 15 years of experience in molecular genetic diagnostics. EMQN-certified lab, recommended by the Polish Society of Human Genetics (PTGC).",
    how_it_works: "How it works",
    choose_your_option: "Select your options below",
    use_kit_and_send_sample: "Use the collection kit and send it to us",
    our_lab_will_test_it: "Our lab will test it according to the selected option",
    download_results: "Collect test results",
    register_video_consultation: "Register for a consultation with one of our clinical geneticists (regular or on-line)",
    why_its_worth_it: "Why is it a good idea?",
    why_genomed: "Why us?",
    security: "Security",
    confidence: "Confidence",
    security_confidence_info: "Nearly 70,000 patients have trusted us so far",
    professionalism: "Professionalism",
    professionalism_info: "Established by researchers, Genomed has 15 years of experience",
    medical_knowledge:"Medical expertise",
    medical_knowledge_info:"We are a team of expert diagnosticians, clinical geneticists, and molecular biologists",
    data_storage:"Secure data storage",
    data_storage_info:"Extensive experience in secure storage of patients’ data and genomic project data",
    polish_reference_database:"Polish Reference Genome Database",
    polish_reference_database_info:"We have co-created a genome database of healthy long-lived Poles (POLGENOM). It is our reference.",
    our_tools:"Our own genome analysis tools",
    our_tools_info:"We use our own in-house developed software for NGS data analysis",
    why_you_should_know_your_genome: "Is getting to know your genome a good idea?",
    why_you_should_know_your_genome_short_description: "<p>Rare diseases affect 6% of the population, which means that over two million Poles have them. The majority of rare diseases are genetic in origin.</p>At present, however, the health care system does not cover the costs of extensive preventive genetic tests.</p><p>Whole-Genome Sequencing (WGS) is a state-of-the-art genetic test that provides new prevention and personalised treatment opportunities as it yields information that never changes and remains valid throughout the patient’s life.</p><p>Having your whole genome analysed provides you with information that helps you and your family to live healthy lives.</p>Your DNA sequence is an instruction, not fate. Getting to know it, you can change your future.</p>",
    what_is_the_difference: "How is whole-genome testing different from other genetic tests?",
    what_is_the_difference_short_description: "Many genetic tests are based on classic molecular biology methods which usually detect several modifications (variants) within selected chromosomes. At different stages in life, each of us is likely to perform several genetic tests, for example for predispositions to developing cancer, such as breast cancer or intestine cancer, or tests to check response to drugs or therapies. Before making a decision on procreation, some couples deliberate a genetic disease carrier status test, wishing to know the risk of passing a damaged gene copy and the associated disease to their children. All this information is available in the DNA, you only need to reveal it once and it will be valid your entire life. Whole genome analysis is performed using Next-Generation Sequencing (NGS) and covers reading almost 100% of the DNA sequence contained in 23 chromosome pairs. Once the whole genome analysis is done, there is no need for any other genetic tests now or in the future. Valid information can be provided to your physician easily and quickly, should such a need arise.",
    counters:{
      header:"We read",
      counter_1:{
        top:"",
        number:"100,000,000,000",
        bottom:"DNA letters",
      },
      counter_2:{
        top:"A sequence of",
        number:"20,000",
        bottom:"protein coding genes",
      },
      counter_3:{
        top:"",
        number:"5,000",
        bottom:"genes associated with genetic diseases",
      },
    },
    tiles:{
      1:"You will get to know your personal risk of developing genetic diseases",
      2:"You will get to know the risk of your children developing genetic diseases",
      3:"You will learn how to prevent and cure them",
      4:"You will know your personal response to medicines and therapies",
      5:"You will identify potential gene therapy or genome edition targets",
      6:"A single test will provide information for a lifetime",
    }
  },
    faq:{
      title:"FAQ",
      description:"faq description",
      article_1_title: "My physician thinks I may have a genetic disease. Is preventive genome test the way to go?",
      article_1_text: "The preventive genome analysis we offer is not a clinically applicable test, although it is more effective than the diagnostic approaches applied so far. However, it aims to detect known pathogenic variants alone. Genetic causes of diseases are revealed through an in-depth, detailed analysis of genomic data focused on specific clinical conditions, i.e. a clinical genome analysis, which we also offer.",
      article_1_read_more: "In the case of genetic diseases with non-specific symptoms or caused by defects of a number of genes, pinpointing their genetic causes can be painstaking, especially if it is based on traditional “gene-by-gene” testing. Of the 20,000 protein-coding genes in our genome, only a few known to be associated with specific symptoms have been analysed so far. In addition, analysis often covered only alterations that have already been detected. Not surprisingly, the search was time-consuming, expensive, and often ineffective. Diseases may be caused by unknown alterations located outside the region under analysis (beyond the so-called ‘coding region’) or in a different gene! Preventive genome analysis reveals the entire genome sequence and all known, clinically significant genes are analysed for known pathogenic or possibly pathogenic alterations entered into ClinVar, as well as alterations that lead to genes losing their function (so-called ‘loss-of-function variants’). The resulting genomic data can be re-analysed at any time, taking into account more genes or alterations that will have been proven to be associated with a given disease in the years to come.",
      article_2_title: "I'm healthy. Why would I need a genome test?",
      article_2_text: "Your future is as important as your health right now. Awareness of your personal genetic status can help you make many important decisions regarding yourself and your life. To gain such knowledge is a choice you should give much though to.",
      article_2_read_more: "The presence of specific genetic variants influences your body's response to many common medicines and affects the risk of many diseases, such as cancer or venous thrombosis. Awareness of your personal genetic status allows selecting the most effective treatment or taking adequate preventive actions. Being predisposed to development of a disease does not mean, however, that it is inevitable. It only means that the risk is higher than in people who are not predisposed. Available preventive actions range from increasing the frequency of medical check-ups, to avoiding additional risk factors, to lifestyle changes and exercise, and to irreversible procedures, such as preventive mastectomy and ovariotomy, as was the case with Angelina Jolie, who inherited a mutation significantly increasing the risk of breast cancer from her mother.",
      article_3_title: "I have my genome test result. What’s next?",
      article_3_text_paragraph_1: "Your genome test has been completed and you have received a report. It comprises a list of genetic variants detected in your genome that are important to your health, along with a detailed description based on up-to-date reliable sources. It also contains detailed information on the test itself. To be able to make sense of it, you need expertise and experience of a clinical geneticist. Make an appointment for a consultation to discuss the result with a doctor and receive instructions on how to proceed.",
      article_3_text_paragraph_2: "You have received a copy of the report and the data it relies on, on a USB stick. The data are valid for a lifetime and can be re-analysed as many times as you wish, taking into account new developments in medicine and science. They can be used for a new in-depth analysis and to draw up a new diagnostic report from a clinical test if you develop a disease that may be genetic. Thus you will not have to pay for processing or sequencing of your genetic material again.",
    },
    about_us:{
      title:"About us",
      numbers_1:"RESULTS ISSUED",
      numbers_2:"PATIENTS DIAGNOSED",
      numbers_3:"SCIENTIFIC PAPERS PUBLISHED",
      paragraph_1_title:'Genomed S.A.',
      paragraph_1_content:'Genomed S.A. is the leading provider of genetic tests and personalised medicine services. Our main goal is to introduce preventive genetic testing to medical practitioners’ routine.<p>We are an innovative company established by a group of researchers, each of whom has many years’ experience and considerable achievements in the field of genomics. The company’s initial public offering on the Warsaw New Connect Stock Exchange took place in 2011.</p><p> We are the indisputable leader in Next-Generation Sequencing (NGS) in Poland, a provider of a vast array of highly advanced NGS services, including complex bioinformatic analyses. Our offer is versatile. The diagnostic part includes genetic testing for patients, hospitals and medical universities, private medical practitioners, and clinical trial centres. The research aspect focuses on the research community as well as biotechnology and pharmaceutical companies.</p><p>Our laboratory has been acclaimed the best private lab that performs genetic testing in Poland in a recent lab ranking.</p>',
      paragraph_2_title:"Our team",
      paragraph_2_content:"Our team is a select group of molecular biologists, genetic diagnosticians, experts in bioinformatics, and clinical geneticists. We keep developing our personalised genomics methods, databases, and software. We provide genetic testing services in a Non-Public Health Care Institution (NZOZ) Genomed and a genetic counselling centre. We currently provide services that consist in DNA analysis and testing for genetic diseases based on DNA sequencing using state-of-the-art genomic technologies to over three hundred research centres, biotechnology companies, and medical institutions. All reputable research and medical centres are our customers.",
      paragraph_3_title:"Polish Reference Genome Database and the ‘Polish genome’",
      paragraph_3_content:'In 2013, we became the leader of a consortium working on <a href="https://www.polgenom.pl/#login" target="_blank">POLGENOM</a>, or the Polish Reference Genome Database. The purpose of the project, implemented in close cooperation with the best molecular biology and medical institutions in Poland, was to further research in personalised medicine and to create a genome database of the Polish subpopulation of the Caucasian race for research and commercial purposes. We have achieved our goal. We have set up a database with a comprehensive set of clinical and biochemical data based on full genomes of 126 healthy long-lived Poles (90+). The database has been put to practical use in the framework of diagnostic processes by genetic testing labs and by pharmaceutical companies, for introduction of new drugs whose effect depends on the patient’s genotype. The dataset serves as a control group for population-based genetic tests of various patient groups.',
      paragraph_4_title:"Original analysis tools",
      paragraph_4_content:"We have developed a set of bioinformatic tools and databases that support data analysis in Next-Generation Sequencing (NGS). Our original BroVar (Variant Browser) software is already available to research centres and diagnostic laboratories on a commercial basis. Tests are performed using our hardware and the results are available on-line. This unique software made in Poland provides researchers and technicians with simultaneous access to Clinvar, Polgenom, and GnomAD databases. It has a module for dynamic variant pathogenicity prediction. It is also unique in that users can flag variants and their functions, which makes BroVar a knowledge-sharing platform.",
      paragraph_5_title:"Our experience",
      paragraph_5_content:"<ul><li>We have many years’ experience in genetic testing and genome sequencing. We were the first lab to apply Next-Generation Sequencing (NGS) to testing purposes in Poland.</li><li>We provided genetic testing services under the Polish Programme of Screening Newborns for cystic fibrosis.</li><li>We are the only company in Poland to perform genome-wide non-invasive prenatal testing (branded as SANCOR)  in our own lab.</li><li>We are the only lab in Poland to perform preventive genetic tests suited to the Polish population (<a href='http://infanotest.pl/' target='_blank'>INFANO</a>&nbsp;and <a href='https://parento.pl/' target='_blank'>PARENTO</a> tests)</li></ul>",
      paragraph_6_title:"Security and confidence",
      paragraph_6_content:"Our lab has been entered onto the list of laboratories kept by the Polish Chamber of Laboratory Diagnosticians (KIDL) under number 2854. It is a member of the Reference Laboratory Network (SLR) of the Polish Society of Human Genetics (PTGC). Since 2008, we have issued genetic test results to nearly 70,000 patients from Poland and abroad. We obtain European Molecular Quality Network (EMQN) and Cystic Fibrosis Network certificates, which prove our services to be of the highest quality, on a regular basis.<br><b>We have the most extensive experience in processing and storage of patients’ genomic data in Poland. We safeguard our patients’ data and monitor our IT systems to minimise the risk of unauthorised access. We do not disclose samples or test results without our patient’s consent. We frequently organise staff trainings in personal data security. We also conduct penetration tests of the websites with test results on a regular basis.</b>",
      paragraph_7_title:"Certificates and distinctions",
      paragraph_7_content:"",
    },
    privacy_policy:{
      title:"Privacy policy",
      content:'<p>Pursuant to Article 13(1) and (2) of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation) (hereinafter referred to as <b>“GDPR”</b>), please be advised that:</p><ol><li>The personal data controller is Genomed S.A. with its registered office in Warsaw at ul. Ponczowa 12, (hereinafter referred to as <b>PDC</b>);</li><li>You can contact the PDC by e-mail: <a href="mailto:iod@genomed.pl">iod@genomed. pl</a>, by phone: (+48) 22 644 60 19, and by post: ul. Ponczowa 12, 02-971 Warszawa;</li><li>The PDC has appointed a Data Protection Officer whom you can contact by e-mail: <a href="mailto:iod@genomed.pl">iod@genomed. pl</a>and by post, the address being the same as above.</li><li>The following personal data are processed: name, surname, company name and registered office address (residence address), e-mail, and telephone No. </li><li> Personal data are processed by the PDC for the following purposes and on the following legal grounds:<div><table class="table table-striped mb-3 mt-3 table-list table-bordered table-hover"><thead><tr> <td><strong>Purpose of data processing</strong></td><td><strong>Legal basis for data processing</strong></td></tr></thead><tbody><tr>< td class="left">Data processing is necessary for execution of a contract to which the data subject is a party or to take actions at the request of the data subject prior to contract execution.</td><td>Article 6(1)(b) of GDPR</td></tr><tr><td class="left">To keep the accounts and fiscal documents. To pursue claims related to economic activity, which is a legitimate interest in data processing by the PDC.</td><td >Article 6(1)(c) of GDPR in conjunction with Article 74(2) of the Polish Act on accounting.</td></tr><tr><td class="left bottom">For Genomed S.A. to send marketing offers and commercial information by electronic means. It does not apply to the "Genetic diagnostics" website.</td><td class="bottom">Article 6(1)(f) of GDPR.</td></tr></tbody></table></div></li><li>Keeping personal data is a statutory condition (it results from the law) and is essential for contract execution: providing services by electronic means, making purchases, and ordering tests via infanotest.pl.</li><li>The above does not apply to voluntary consents to personal data use for marketing purposes.</li><li>Your personal data will be disclosed to:<ol><li>PDC employees/associates authorised to process the data at the request of the PDC;</li><li>The entities entrusted by the PDC with the processing of personal data, such as: <ul><li>Providers of legal and advisory services if the PDC would have to pursue claims related to economic activity;< /li><li>The entities with whom the PDC has concluded contracts for the provision of services;</li></ul>With all precautions to ensure security of transferred data.</li></ol></li><li>The data are stored by the PDC for:<table class="policy table table-striped mb-3 mt-3 table-list table-bordered table-hover"><thead><tr><td><strong>Purpose of data processing</ strong></td><td><strong>Data storage period</strong></td></tr></thead><tbody><tr><td>Data processing is necessary for execution of a contract to which the data subject is a party or to take actions at the request of the data subject prior to contract execution.</td><td>The storage period of accounting and fiscal documents is defined by the law.</td></tr><tr><td> To pursue claims related to economic activity</td><td>Claims barred by the statute of limitations defined by the law.</td></tr><tr><td>To keep accounts and fiscal documents.</td><td>The storage period of accounting and fiscal documents is defined by the law.</td></tr><tr><td>For Genomed S.A. to send marketing offers and commercial information by electronic means. It does not apply to the "Genetic diagnostics" website.</td><td>Until an effective objection is raised or consent is withdrawn.</td></tr></tbody></table></li><li>You have the right to access  your data and rectify them if incorrect;</li><li>In cases defined by law, you have the right to request data deletion, demand restriction of data processing, transfer data, and object to data processing. You can edit and delete the personal data you provided at: http:/genomed.nauka/index.php/pl/nauka, "My account" tab;</li><li>No automated decisions (decisions without human participation) will be made in relation to your personal data, and your data will not be subject to profiling;</li><li>If the PDC violates the regulations on personal data protection when processing your data, you have the right to lodge a complaint with the supervisory body – the President of the Personal Data Protection Office (UODO).</li></ol><h2>Security rules</h2><p>Pursuant to Article 32 of GDPR, Genomed S.A. ensures security of personal data by implementing appropriate technical and organisational measures aimed at preventing unlawful data processing and their accidental loss, destruction, and damage.</p><p>We use the most secure data transfer protection mechanisms currently available.</p <p>The transmission protocol we use, namely SSL (Secure Socket Layer), ensures security of data transmission on the Internet. It consisting in encoding data before they are sent from the client’s browser and decoding them after safely reaching the store server. Information sent from the server to the client is also encoded and decoded upon arrival.</p><p>SSL encrypts, authenticates, and ensures message integrity. When connection with a secure website (i.e. one which applies SSL) is established, encryption keys are determined, and then they are used when transferring data between the browser on the client’s computer and the store server. Both the key determination procedure and the transmission are very difficult to hack. Users are notified when they connect with a secure website.</p><ul><li>In Internet Explorer, a padlock is displayed on the right hand side of the status bar. Clicking it displays the authenticity certificate (digital signature) of the website. </li><li>In Firefox and Opera, the padlock is displayed on the navigation bar. Clicking it displays the website’s authenticity certificate. </li></ul><p>For your own security, always remember to sign out when you are finished. To do this, click the “Log out” button in the upper right corner.<br>Just closing the browser window will not sign you out.</p>',
    },
    contact:{
      title:"Contact details",
      description:"To do",
    },
  }

export default en_translation;



// WEBPACK FOOTER //
// ./src/translations/en.js